import styled from '@emotion/styled';

const Fieldset = styled.fieldset`
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  label {
    margin: 0;
    font-weight: normal;
  }
  legend {
    width: auto !important;
    font-weight: 600;
    font-size: 13px;
    margin-bottom: -5px;
  }
`;

export default Fieldset;
